// React
import { useEffect, useState } from "react"

// Types
import type { SuccessFetch } from "types"

// Utils
import { useApi } from "utils"

// Types
interface Type {
  mr_unit_name: string
  product_code: string
  product_ingredient_id: number
  product_name: string
}
interface FetchComponentType extends Type {
  available: string
  back_order: string
  commited: string
  qty: string
  soh: string
}
interface DataComponentType extends Type {
  available: number
  back_order: number
  commited: number
  qty: number
  soh: number
}

export function useComponentList(
  product_id: number,
  qty_order: number
): {
  data: DataComponentType[]
  isLoading: boolean
} {
  // Hooks
  const api = useApi()
  const [data, setData] = useState<DataComponentType[]>([])
  const [isLoading, setLoading] = useState<boolean>(true)

  useEffect(() => {
    api.get(
      "/requestform/product_ingredient",
      {
        params: {
          product_id,
          qty_order
        }
      }
    ).then((res: SuccessFetch<{
      payload: FetchComponentType[]
    }>) => {
      setData(res.data.payload.map(item => {
        return {
          ...item,
          available: parseFloat(item.available),
          back_order: parseFloat(item.back_order),
          commited: parseFloat(item.commited),
          qty: parseFloat(item.qty),
          soh: parseFloat(item.soh)
        }
      }))
    }).catch(() => {
      setData([])
    }).finally(() => {
      setLoading(false)
    })

    return () => {
      setData([])
      setLoading(true)
    }

    // eslint-disable-next-line
  }, [])

  return { data, isLoading }
}